(() => {
  'use strict';
  const shell = document.querySelector('[data-ng-product]');
  if (!shell) return;
  const data = JSON.parse(shell.querySelector('[data-ng-product-json]').textContent);
  const form = document.getElementById('NovaProductForm');
  const currency = data.currency;
  const error = shell.querySelector('[data-ng-product-error]');
  const sizeNotice = shell.querySelector('[data-ng-size-notice]');
  const sticky = document.querySelector('[data-ng-sticky-buy]');
  const stickyAdd = document.querySelector('[data-ng-sticky-add]');
  const add = shell.querySelector('[data-ng-add]');
  const basePrice = 8650;
  const discount = { 1: 0, 2: 2495, 3: 3990 };
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
  let busy = false;
  let checkoutMode = false;
  let validationAttempted = false;
  const orderOptions = window.NovaOrderOptions;
  const selectedOptions = {support:false, processing:false};

  // Resolve the real variant from its native option text, never from a guessed ID.
  // The supplier's metric labels are translated to feet only in the shopper UI.
  function treeSize(variant) {
    const options = Array.isArray(variant.options) ? variant.options : [];
    const label = [...options, variant.title || ''].join(' ').toLowerCase();
    const feet = label.match(/\b([567])\s*(?:ft|feet|foot)\b/);
    if (feet) return Number(feet[1]);
    const metres = label.match(/\b(1[.,]5|1[.,]8|2[.,]1)\s*(?:m\b|met(?:er|re)s?\b)/);
    if (metres) return { '1.5': 5, '1.8': 6, '2.1': 7 }[metres[1].replace(',', '.')];
    return null;
  }
  const variants = Array.isArray(data.variants) ? data.variants : [];
  const variantsBySize = new Map();
  for (const size of [5, 6, 7]) {
    const matches = variants.filter(variant => treeSize(variant) === size);
    // An ambiguous option is not safe to order automatically.
    if (matches.length === 1) variantsBySize.set(size, matches[0]);
  }
  // Start every kit at the available 6 ft size; shoppers can still mix sizes.
  const defaultSize = variantsBySize.get(6)?.available ? 6 : null;
  const selectedSizes = [defaultSize, defaultSize, defaultSize];
  const explicitVariant = new URL(location.href).searchParams.get('variant');
  if (explicitVariant) {
    const selected = [...variantsBySize].find(([, variant]) => String(variant.id) === explicitVariant && variant.available);
    if (selected) selectedSizes[0] = selected[0];
    else {
      selectedSizes[0] = null;
      if (sizeNotice) sizeNotice.hidden = false;
    }
  }

  function selection() {
    const qty = Number(form.querySelector('[name="quantity"]:checked')?.value || 1);
    const chosen = selectedSizes.slice(0, qty).map(size => variantsBySize.get(size));
    return { qty, chosen, variant: chosen[0] || data.variant };
  }
  function total(variant, qty) {
    return variant.price * qty - Math.round(discount[qty] * (variant.price / basePrice));
  }
  function missingChoice() {
    const { chosen } = selection();
    return chosen.findIndex(variant => !variant || !variant.available);
  }
  function activeSelect(slot) {
    return form.querySelector(`[data-ng-pack-sizes="${selection().qty}"] [data-ng-tree-slot="${slot}"]`);
  }
  function syncPickers() {
    const { qty } = selection();
    form.querySelectorAll('[data-ng-pack-card]').forEach(card => {
      const active = Number(card.dataset.ngPackCard) === qty;
      card.classList.toggle('is-selected', active);
      const panel = card.querySelector('[data-ng-pack-sizes]');
      panel.hidden = !active;
      card.querySelector('[name="quantity"]').disabled = busy;
      panel.querySelectorAll('[data-ng-tree-size]').forEach(select => {
        const slot = Number(select.dataset.ngTreeSlot);
        select.disabled = !active || busy;
        for (const option of select.options) {
          if (option.value) option.disabled = !variantsBySize.get(Number(option.value))?.available;
        }
        select.value = selectedSizes[slot] ? String(selectedSizes[slot]) : '';
        const invalid = active && validationAttempted && (!variantsBySize.get(selectedSizes[slot])?.available);
        select.setAttribute('aria-invalid', String(invalid));
      });
    });
    // The first tree drives the shareable URL; subsequent tree choices stay intact.
    const first = variantsBySize.get(selectedSizes[0]);
    const hiddenVariant = form.querySelector('[data-ng-variant]');
    hiddenVariant.value = first?.available ? String(first.id) : '';
    hiddenVariant.disabled = !first?.available;
    const url = new URL(location.href);
    if (first?.available) url.searchParams.set('variant', String(first.id));
    else url.searchParams.delete('variant');
    history.replaceState(history.state, '', url);
  }
  function showChoiceError(focus) {
    const slot = missingChoice();
    if (slot < 0) return false;
    validationAttempted = true;
    error.textContent = selection().qty === 1 ? 'Please choose the size for your tree.' : `Please choose a size for tree ${slot + 1}.`;
    error.hidden = false;
    syncPickers();
    if (focus) {
      const select = activeSelect(slot);
      select?.focus({ preventScroll: true });
      select?.scrollIntoView({ block: 'center', behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    return true;
  }
  function updateSavings(variant, qty) {
    const compare = Number(variant.compareAtPrice || 0) * qty;
    const price = total(variant, qty);
    const valid = compare > variant.price * qty;
    const percent = valid ? Math.round((compare - price) / compare * 100) : 0;
    const old = shell.querySelector('[data-ng-compare-price]');
    const badge = shell.querySelector('[data-ng-price-saving]');
    const gallery = shell.querySelector('[data-ng-gallery-sale]');
    old.hidden = badge.hidden = gallery.hidden = !valid;
    old.textContent = valid ? money(compare) : '';
    badge.textContent = gallery.textContent = valid ? 'SAVE ' + percent + '%' : '';
  }
  function update() {
    const { variant, qty } = selection();
    syncPickers();
    const optionTotal = orderOptions?.updateProduct(shell, qty, selectedOptions, busy, window.NovaCart?.getCart()) || 0;
    shell.querySelector('[data-ng-price]').textContent = money(total(variant, qty));
    updateSavings(variant, qty);
    for (let count = 1; count <= 3; count++) {
      const price = total(variant, count);
      shell.querySelector(`[data-ng-pack-price="${count}"]`).textContent = money(price);
      shell.querySelector(`[data-ng-pack-each="${count}"]`).textContent = `${money(Math.round(price / count))} each`;
      const baseline = Number(variant.compareAtPrice || 0) > variant.price ? Number(variant.compareAtPrice) * count : variant.price * count;
      const saved = baseline - price;
      const saving = shell.querySelector(`[data-ng-pack-saving="${count}"]`);
      const compare = shell.querySelector(`[data-ng-pack-compare="${count}"]`);
      saving.hidden = saved <= 0;
      saving.textContent = `Save ${money(saved)} · ${Math.round(saved / baseline * 100)}% off`;
      compare.hidden = !(Number(variant.compareAtPrice || 0) > variant.price);
      compare.textContent = compare.hidden ? '' : money(baseline);
    }
    shell.querySelector('[data-ng-pack-property]').value = `${qty} ${qty === 1 ? 'kit' : 'kits'}`;
    shell.querySelector('[data-ng-gift-property]').value = qty >= 2 ? 'Star topper and spare extension set with 2 or more kits per order; mystery gift included in this bundle' : 'Free shipping and one free mystery gift per order';
    shell.querySelectorAll('[data-ng-gift]').forEach(gift => gift.classList.toggle('is-unlocked', qty >= Number(gift.dataset.ngGift)));
    const mysteryLabel = shell.querySelector('[data-ng-mystery-included]');
    if (mysteryLabel) mysteryLabel.textContent = qty === 1 ? 'Included with your kit' : 'Included in your gift bundle';
    shell.querySelector('[data-ng-shipping-value]').textContent = money(Math.round(550 * variant.price / basePrice));
    shell.querySelector('[data-ng-topper-value]').textContent = money(Math.round(2999 * variant.price / basePrice));
    shell.querySelector('[data-ng-gifts-status]').textContent = qty >= 2 ? 'GIFTS UNLOCKED' : 'YOUR FREE GIFTS';
    shell.querySelector('[data-ng-currency-estimate]').hidden = currency === 'USD';
    const anyAvailable = [...variantsBySize.values()].some(item => item.available);
    add.disabled = busy || !anyAvailable;
    shell.querySelector('[data-ng-add-label]').textContent = busy ? (checkoutMode ? 'OPENING CHECKOUT…' : 'ADDING…') : anyAvailable ? 'ADD TO CART' : 'UNAVAILABLE';
    if (stickyAdd) {
      stickyAdd.disabled = busy || !anyAvailable;
      stickyAdd.querySelector('[data-ng-sticky-add-label]').textContent = busy ? (checkoutMode ? 'OPENING…' : 'ADDING…') : anyAvailable ? 'BUY NOW' : 'UNAVAILABLE';
    }
    document.querySelector('[data-ng-sticky-price]').textContent = money(total(variant, qty) + optionTotal);
    const stickyRegular = Number(variant.compareAtPrice || 0) * qty + optionTotal;
    const stickySale = total(variant, qty) + optionTotal;
    const stickyCompare = document.querySelector('[data-ng-sticky-compare]');
    const stickyDiscount = document.querySelector('[data-ng-sticky-discount]');
    stickyCompare.hidden = stickyDiscount.hidden = !(stickyRegular > stickySale);
    stickyDiscount.hidden = stickyDiscount.hidden || optionTotal > 0;
    stickyCompare.textContent = money(stickyRegular);
    stickyDiscount.textContent = Math.round((stickyRegular - stickySale) / stickyRegular * 100) + '% OFF';
    const sizes = selectedSizes.slice(0, qty);
    const sizeLabel = sizes.some(size => !variantsBySize.get(size)?.available)
      ? 'Choose size'
      : new Set(sizes).size === 1
        ? sizes[0] + ' ft ' + (qty === 1 ? 'tree' : 'trees')
        : sizes.join(' / ') + ' ft';
    document.querySelector('[data-ng-sticky-quantity]').textContent = qty + ' ' + (qty === 1 ? 'kit' : 'kits') + ' · ' + sizeLabel;
  }

  // The page cannot submit the legacy default variant if the size code or cart fails.
  // Initial HTML has a disabled submit button and empty, disabled native variant input.
  form.noValidate = true;
  form.addEventListener('change', event => {
    if (event.target.matches('[data-ng-order-option]')) {
      selectedOptions[event.target.dataset.ngOrderOption] = event.target.checked;
    }
    if (event.target.matches('[data-ng-tree-size]')) {
      selectedSizes[Number(event.target.dataset.ngTreeSlot)] = Number(event.target.value) || null;
      if (sizeNotice) sizeNotice.hidden = true;
    }
    error.hidden = true;
    update();
    if (validationAttempted) showChoiceError(false);
  });
  async function purchase(event, directCheckout = false) {
    event.preventDefault();
    if (busy || showChoiceError(true)) return;
    error.hidden = true;
    checkoutMode = directCheckout;
    if (!window.NovaCart?.[directCheckout ? 'buyNow' : 'add']) {
      error.textContent = 'We could not prepare your cart. Please refresh the page and try again.';
      error.hidden = false;
      return;
    }
    const chosen = selection().chosen;
    if (chosen.some(variant => !String(variant.sku || '').trim() || !String(variant.supplierKitSize || '').trim())) {
      error.textContent = 'We could not prepare your selected kit. Please refresh the page and try again.';
      error.hidden = false;
      return;
    }
    // Supplier details are saved on each order line; underscore keys stay private at checkout.
    // Mixed-size bundles are one atomic cart add; identical sizes share a line.
    const grouped = new Map();
    for (const variant of chosen) {
      const existing = grouped.get(variant.id);
      if (existing) existing.quantity++;
      else grouped.set(variant.id, {
        id: variant.id,
        quantity: 1,
        properties: {
          '_Supplier kit size': variant.supplierKitSize,
          '_Supplier SKU': variant.sku
        }
      });
    }
    busy = true;
    update();
    try {
      await window.NovaCart[directCheckout ? 'buyNow' : 'add']({ items: [...grouped.values()], orderOptions: {...selectedOptions} });
      if (!directCheckout) busy = false;
    } catch (exception) {
      busy = Boolean(exception.kitAdded);
      error.textContent = exception.kitAdded
        ? 'Your kit is in your bag. ' + exception.message + ' Please refresh the page and use the bag checkout to avoid adding it twice.'
        : exception.message || 'We could not prepare checkout. Please try again.';
      error.hidden = false;
    } finally {
      update();
    }
  }
  form.addEventListener('submit', event => purchase(event));
  document.addEventListener('nova:cartupdated', update);
  stickyAdd?.addEventListener('click', event => purchase(event, true));
  update();
  // The purchase bar stays available from the top of the product page.
  if (sticky) sticky.hidden = false;
 const thumbs=[...shell.querySelectorAll('[data-ng-gallery-thumb]')];let image=0;const show=n=>{image=(n+thumbs.length)%thumbs.length;const t=thumbs[image],main=shell.querySelector('[data-ng-gallery-main]');main.src=t.dataset.src;main.alt=t.dataset.alt;shell.querySelector('[data-ng-gallery-count]').textContent=`${image+1} / ${thumbs.length}`;thumbs.forEach((b,i)=>b.setAttribute('aria-current',String(i===image)));};thumbs.forEach((t,i)=>t.addEventListener('click',()=>show(i)));shell.querySelector('[data-ng-gallery-prev]').addEventListener('click',()=>show(image-1));shell.querySelector('[data-ng-gallery-next]').addEventListener('click',()=>show(image+1));let touchX=null;const stage=shell.querySelector('.ng-gallery__stage');stage.addEventListener('touchstart',e=>{touchX=e.changedTouches[0].clientX;},{passive:true});stage.addEventListener('touchend',e=>{if(touchX!==null&&Math.abs(e.changedTouches[0].clientX-touchX)>45)show(image+(e.changedTouches[0].clientX<touchX?1:-1));touchX=null;},{passive:true});

})();
